import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AuthenticationService } from '../../services/authentication.service';
import { UserService } from '../../services/user.service';
import { AlertService } from '../../services/alert.service';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { APP_ROUTES } from '../../contants/APP_ROUTES';

@Component({
	selector: 'app-change-password',
	templateUrl: './change-password.component.html',
	styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {
	form: FormGroup;
	
	returnUrl;
	showLoader: boolean = false;

	constructor(
		private _userService: UserService,
		private _alertService: AlertService,
		private _router: Router,
		private _location: Location
	) { }

	ngOnInit() {
		this.form = this.createForm();
	}

	changePassword(formValue) {
		if(!this.form.valid || formValue.newPassword != formValue.validatePassword){
			this._alertService.showError('Input data is invalid.');
			return;
		}

		this._userService.changePassword(formValue.currentPassword, formValue.newPassword).subscribe(
			result => {
				if(result.errors == undefined){
					this._alertService.showGenericError();
				}
				else if(result.errors.length > 0){
					this._alertService.displayErrorResult(result);
				}
				else{
					this._alertService.showSuccess('Your password has been changed.');
					this._router.navigate([APP_ROUTES.userProfile.replace('/:id', ''), 0]);
				}
			}
		);
	}

	cancel() {
		this._location.back();
	}

	isControlInvalid(controlName: string) {
		let control = this.form.controls[controlName];
		return control.invalid && (control.dirty || control.touched);
	}

	private createForm(): FormGroup {
		return new FormGroup({
			currentPassword: new FormControl("", [
				Validators.required,
				Validators.minLength(8),
				Validators.maxLength(20)
			]),
			newPassword: new FormControl("", [
				Validators.required,
				Validators.minLength(8),
				Validators.maxLength(20)
			]),
			validatePassword: new FormControl("", [
				Validators.required,
				Validators.minLength(8),
				Validators.maxLength(20)
			])
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/components/change-password/change-password.component.ts